
import React from 'react';
import ProductsSection from './mobile/ProductsSection';
import SolutionsSection from './mobile/SolutionsSection';
import ResourcesSection from './mobile/ResourcesSection';
import CompanySection from './mobile/CompanySection';
import MenuLink from './mobile/MenuLink';
import AuthButton from './mobile/AuthButton';
import SignUpButton from './mobile/SignUpButton';
import PricingSection from './mobile/PricingSection';

interface MobileMenuProps {
  onClose: () => void;
}

const MobileMenu = ({ onClose }: MobileMenuProps) => {
  return (
    <div className="md:hidden bg-synthreo-black-light border-t border-gray-800">
      <div className="max-h-screen overflow-y-auto">
        <nav className="grid grid-cols-1 divide-y divide-gray-800">
          <ProductsSection onClose={onClose} />
          <SolutionsSection onClose={onClose} />
          <ResourcesSection onClose={onClose} />
          
          <PricingSection onClose={onClose} />
          
          <CompanySection onClose={onClose} />
          
          <div className="py-2">
            <ul>
              <MenuLink
                route="/partners"
                title="Partners"
                onClick={onClose}
              />
            </ul>
          </div>
          
          <ul className="space-y-2 p-4">
            <AuthButton onClose={onClose} />
            <SignUpButton onClose={onClose} />
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
